/**
 * bic-bim-api
 * Import from bic-bim-api Function App
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AsyncCheckResponse } from '../model/asyncCheckResponse';
import { BasecheckBody } from '../model/basecheckBody';
import { BcfTopic } from '../model/bcfTopic';
import { CheckIdsBody } from '../model/checkIdsBody';
import { CheckLodBody } from '../model/checkLodBody';
import { CheckLoiBody } from '../model/checkLoiBody';
import { CheckStatusResponse } from '../model/checkStatusResponse';
import { Checkruleset } from '../model/checkruleset';
import { ConvertIdsToJsonResponse } from '../model/convertIdsToJsonResponse';
import { ConvertLoiToJsonResponse } from '../model/convertLoiToJsonResponse';
import { ErrorResponse } from '../model/errorResponse';
import { FillbimbasistemplateBody } from '../model/fillbimbasistemplateBody';
import { FillidstemplateBody } from '../model/fillidstemplateBody';
import { FillloitemplateBody } from '../model/fillloitemplateBody';
import { GenerateFlbBody } from '../model/generateFlbBody';
import { GeneratesharedparametersBody } from '../model/generatesharedparametersBody';
import { HoaicheckBody } from '../model/hoaicheckBody';
import { IdsExcelToJsonResponse } from '../model/idsExcelToJsonResponse';
import { Json2BcfResponse } from '../model/json2BcfResponse';
import { LoiCheckingRule } from '../model/loiCheckingRule';
import { LoiExcelError } from '../model/loiExcelError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BimService {

    protected basePath = 'https://services.thinkbic.de/bim';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * base-check
     * Startet einen asynchronen BIM-Basis-Check für eine IFC-Datei. Der Status kann über /status abgefragt werden.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public baseCheck(body?: BasecheckBody, observe?: 'body', reportProgress?: boolean): Observable<AsyncCheckResponse>;
    public baseCheck(body?: BasecheckBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AsyncCheckResponse>>;
    public baseCheck(body?: BasecheckBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AsyncCheckResponse>>;
    public baseCheck(body?: BasecheckBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AsyncCheckResponse>('post',`${this.basePath}/base-check`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * bcf2json
     * Konvertiert eine BCF-Datei (BIM Collaboration Format) in JSON.
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bcf2jsonForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<BcfTopic>>;
    public bcf2jsonForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BcfTopic>>>;
    public bcf2jsonForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BcfTopic>>>;
    public bcf2jsonForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<Array<BcfTopic>>('post',`${this.basePath}/bcf2json`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IDS Check starten
     * Startet einen IDS-Check gegen eine IFC-Datei. Die IDS wird als XML-String im JSON-Body übergeben. 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkIds(body?: CheckIdsBody, observe?: 'body', reportProgress?: boolean): Observable<AsyncCheckResponse>;
    public checkIds(body?: CheckIdsBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AsyncCheckResponse>>;
    public checkIds(body?: CheckIdsBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AsyncCheckResponse>>;
    public checkIds(body?: CheckIdsBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AsyncCheckResponse>('post',`${this.basePath}/checkIds`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * check_lod
     * Startet einen asynchronen LOD-Check für eine IFC-Datei. Der Status kann über /status abgefragt werden.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkLod(body?: CheckLodBody, observe?: 'body', reportProgress?: boolean): Observable<AsyncCheckResponse>;
    public checkLod(body?: CheckLodBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AsyncCheckResponse>>;
    public checkLod(body?: CheckLodBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AsyncCheckResponse>>;
    public checkLod(body?: CheckLodBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AsyncCheckResponse>('post',`${this.basePath}/check_lod`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * check_loi
     * Startet einen asynchronen LOI-Check für eine IFC-Datei mit definierten Prüfregeln. Der Status kann über /status abgefragt werden.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkLoi(body?: CheckLoiBody, observe?: 'body', reportProgress?: boolean): Observable<AsyncCheckResponse>;
    public checkLoi(body?: CheckLoiBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AsyncCheckResponse>>;
    public checkLoi(body?: CheckLoiBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AsyncCheckResponse>>;
    public checkLoi(body?: CheckLoiBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AsyncCheckResponse>('post',`${this.basePath}/check_loi`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * convert_ids_to_json
     * Konvertiert eine LOI-Attributliste (Excel) in eine IDS-XML. Analog zu convert-loi-to-json, aber das Ergebnis ist eine IDS-XML als String. Die gleiche Excel-Vorlage wie beim LOI-Import wird verwendet. Jedes Sheet (außer Deckblatt) wird zu einer IDS-Spezifikation. Unterstützt Filterung nach Trade (Verantwortlich), IFC-Version und LOI-Level. 
     * @param file 
     * @param trade 
     * @param ifcVersion 
     * @param lodLevel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public convertIdsToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'body', reportProgress?: boolean): Observable<ConvertIdsToJsonResponse>;
    public convertIdsToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConvertIdsToJsonResponse>>;
    public convertIdsToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConvertIdsToJsonResponse>>;
    public convertIdsToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (trade !== undefined) {
            formParams = formParams.append('trade', <any>trade) as any || formParams;
        }
        if (ifcVersion !== undefined) {
            formParams = formParams.append('ifcVersion', <any>ifcVersion) as any || formParams;
        }
        if (lodLevel !== undefined) {
            formParams = formParams.append('lodLevel', <any>lodLevel) as any || formParams;
        }

        return this.httpClient.request<ConvertIdsToJsonResponse>('post',`${this.basePath}/convert-ids-to-json`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * convert_loi_to_json
     * Konvertiert eine LOI-Attributliste (Excel) in das LOI-Check JSON-Format.
     * @param file 
     * @param trade 
     * @param ifcVersion 
     * @param lodLevel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public convertLoiToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'body', reportProgress?: boolean): Observable<ConvertLoiToJsonResponse>;
    public convertLoiToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConvertLoiToJsonResponse>>;
    public convertLoiToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConvertLoiToJsonResponse>>;
    public convertLoiToJsonForm(file?: Blob, trade?: string, ifcVersion?: string, lodLevel?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (trade !== undefined) {
            formParams = formParams.append('trade', <any>trade) as any || formParams;
        }
        if (ifcVersion !== undefined) {
            formParams = formParams.append('ifcVersion', <any>ifcVersion) as any || formParams;
        }
        if (lodLevel !== undefined) {
            formParams = formParams.append('lodLevel', <any>lodLevel) as any || formParams;
        }

        return this.httpClient.request<ConvertLoiToJsonResponse>('post',`${this.basePath}/convert-loi-to-json`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fill_bim_basis_template
     * Befüllt eine BIM-Basis-Check Excel-Vorlage mit den übergebenen Regeln und gibt die befüllte Excel-Datei zurück.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fillBimBasisTemplate(body?: FillbimbasistemplateBody, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public fillBimBasisTemplate(body?: FillbimbasistemplateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public fillBimBasisTemplate(body?: FillbimbasistemplateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public fillBimBasisTemplate(body?: FillbimbasistemplateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Blob>('post',`${this.basePath}/fill-bim-basis-template`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fill_ids_template
     * Befüllt eine Excel-Vorlage (gleiches Template wie LOI) mit IDS-Check-Ergebnissen und gibt die befüllte Excel-Datei zurück.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fillIdsTemplate(body?: FillidstemplateBody, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public fillIdsTemplate(body?: FillidstemplateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public fillIdsTemplate(body?: FillidstemplateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public fillIdsTemplate(body?: FillidstemplateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Blob>('post',`${this.basePath}/fill-ids-template`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fill_loi_template
     * Befüllt eine LOI-Excel-Vorlage mit den übergebenen JSON-Daten und gibt die befüllte Excel-Datei zurück.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fillLoiTemplate(body?: FillloitemplateBody, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public fillLoiTemplate(body?: FillloitemplateBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public fillLoiTemplate(body?: FillloitemplateBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public fillLoiTemplate(body?: FillloitemplateBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Blob>('post',`${this.basePath}/fill-loi-template`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * generate_flb
     * Generiert eine FLB aus einer IFC-Datei.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateFlb(body?: GenerateFlbBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public generateFlb(body?: GenerateFlbBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public generateFlb(body?: GenerateFlbBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public generateFlb(body?: GenerateFlbBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/generate_flb`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * generate_shared_parameters
     * Generiert eine Revit Shared Parameters Textdatei aus einer Excel-Datei.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateSharedParameters(body?: GeneratesharedparametersBody, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public generateSharedParameters(body?: GeneratesharedparametersBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public generateSharedParameters(body?: GeneratesharedparametersBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public generateSharedParameters(body?: GeneratesharedparametersBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/generate-shared-parameters`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * hoai-check
     * Startet einen asynchronen HOAI-Check für eine IFC-Datei. Der Status kann über /status abgefragt werden.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hoaiCheck(body?: HoaicheckBody, observe?: 'body', reportProgress?: boolean): Observable<AsyncCheckResponse>;
    public hoaiCheck(body?: HoaicheckBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AsyncCheckResponse>>;
    public hoaiCheck(body?: HoaicheckBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AsyncCheckResponse>>;
    public hoaiCheck(body?: HoaicheckBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AsyncCheckResponse>('post',`${this.basePath}/hoai-check`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ids_excel_to_json
     * Konvertiert eine IDS-Excel-Datei in ein Prüfregelformat (JSON). Die Excel-Datei enthält 4 Sheets (Metadaten, Spezifikationen, Anwendbarkeit, Anforderungen). Unterstützt mehrere Facetten pro Zeile, Aufzählungen (\&quot;;\&quot;), Muster (\&quot;MUSTER&#x3D;\&quot;) und Bereiche (\&quot;MIN&#x3D;/MAX&#x3D;\&quot;). Äquivalent zu loi_excel_to_json für den IDS-Workflow. 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public idsExcelToJsonForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<IdsExcelToJsonResponse>;
    public idsExcelToJsonForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IdsExcelToJsonResponse>>;
    public idsExcelToJsonForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IdsExcelToJsonResponse>>;
    public idsExcelToJsonForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<IdsExcelToJsonResponse>('post',`${this.basePath}/ids_excel_to_json`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IDS zu BIC-Prüfregeln konvertieren
     * Konvertiert eine IDS-Datei oder ein IDS-JSON-Objekt in das BIC-Prüfregelformat (Checkruleset). Akzeptiert entweder eine IDS-Datei als Upload oder ein IDS-JSON-Objekt im Body. 
     * @param file 
     * @param name Name des Regelsets (optional, wird sonst aus IDS-Titel genommen)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public idsToCheckrulesetForm(file?: Blob, name?: string, observe?: 'body', reportProgress?: boolean): Observable<Checkruleset>;
    public idsToCheckrulesetForm(file?: Blob, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Checkruleset>>;
    public idsToCheckrulesetForm(file?: Blob, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Checkruleset>>;
    public idsToCheckrulesetForm(file?: Blob, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data',
            'application/json'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<Checkruleset>('post',`${this.basePath}/idsToCheckruleset`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IDS zu BIC-Prüfregeln konvertieren
     * Konvertiert eine IDS-Datei oder ein IDS-JSON-Objekt in das BIC-Prüfregelformat (Checkruleset). Akzeptiert entweder eine IDS-Datei als Upload oder ein IDS-JSON-Objekt im Body. 
     * @param body 
     * @param name Name des Regelsets (optional, wird sonst aus IDS-Titel genommen)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public idsToCheckruleset(body?: any, name?: string, observe?: 'body', reportProgress?: boolean): Observable<Checkruleset>;
    public idsToCheckruleset(body?: any, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Checkruleset>>;
    public idsToCheckruleset(body?: any, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Checkruleset>>;
    public idsToCheckruleset(body?: any, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data',
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Checkruleset>('post',`${this.basePath}/idsToCheckruleset`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * json2bcf
     * Konvertiert JSON-Daten zurück in eine BCF-Datei und gibt Download-URLs zurück.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public json2bcf(body?: Array<BcfTopic>, observe?: 'body', reportProgress?: boolean): Observable<Json2BcfResponse>;
    public json2bcf(body?: Array<BcfTopic>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Json2BcfResponse>>;
    public json2bcf(body?: Array<BcfTopic>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Json2BcfResponse>>;
    public json2bcf(body?: Array<BcfTopic>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Json2BcfResponse>('post',`${this.basePath}/json2bcf`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * loi_excel_to_json
     * Konvertiert eine LOI-Check Excel-Datei (BIC-Vorlage) in ein JSON-Format mit Prüfregeln.
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loiExcelToJsonForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<LoiCheckingRule>>;
    public loiExcelToJsonForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoiCheckingRule>>>;
    public loiExcelToJsonForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoiCheckingRule>>>;
    public loiExcelToJsonForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<Array<LoiCheckingRule>>('post',`${this.basePath}/loi_excel_to_json`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * status
     * Gibt den Status eines laufenden oder abgeschlossenen asynchronen Checks zurück.
     * @param instanceId Instance ID des gestarteten Checks
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public status(instanceId: string, observe?: 'body', reportProgress?: boolean): Observable<CheckStatusResponse>;
    public status(instanceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CheckStatusResponse>>;
    public status(instanceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CheckStatusResponse>>;
    public status(instanceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (instanceId === null || instanceId === undefined) {
            throw new Error('Required parameter instanceId was null or undefined when calling status.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (instanceId !== undefined && instanceId !== null) {
            queryParameters = queryParameters.set('instanceId', <any>instanceId);
        }

        let headers = this.defaultHeaders;

        // authentication (apiKeyHeader) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]) {
            headers = headers.set('Ocp-Apim-Subscription-Key', this.configuration.apiKeys["Ocp-Apim-Subscription-Key"]);
        }

        // authentication (apiKeyQuery) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["subscription-key"]) {
            queryParameters = queryParameters.set('subscription-key', this.configuration.apiKeys["subscription-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CheckStatusResponse>('get',`${this.basePath}/status`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
